import { supabase } from './client';
import ErrorHandler from '@/utils/ErrorHandler';

export const isSetupUnavailable = error => error?.code === 'PGRST202' || error?.status === 404;

const setupRpc = async (name, organizationID, params = {}) => {
    const { data, error } = await supabase.rpc(name, { p_organization_id: organizationID, ...params });
    if (error) throw error;
    if (data?.organizationID !== organizationID) throw new Error('Organization setup context changed');
    return data;
};

export const getOrganizationSetup = organizationID => setupRpc('get_organization_setup', organizationID);
export const resolveOrganizationSetupTask = ({ organizationID, taskID, status = 'completed' }) =>
    setupRpc('resolve_organization_setup_task', organizationID, { p_task_id: taskID, p_status: status });

// Import has no single server transaction: record only after all writes
// succeed, including imports without Source IDs/ImportAssociations.
export const recordPeopleImportSetup = async organizationID => {
    try {
        await resolveOrganizationSetupTask({ organizationID, taskID: 'import' });
    } catch (error) {
        if (!isSetupUnavailable(error) && error?.code !== '42501') {
            ErrorHandler(Error(error.message), { mutation: 'recordPeopleImportSetup' });
        }
    }
};
